import StaffDisplay from "components/BookaMeeting/StaffDisplay";
import EmailIcon from "assets/icons/email.svg?react";

import styles from "./Safeguarding.module.css";

const Safeguarding = ({ safeguardingTeam }) => {
    return (
        <div className={styles.safeguarding} data-testid="safeguarding-team">
            <h1 className={styles.safeguardingTitle}>Safeguarding Team</h1>
            {safeguardingTeam.map((member, index) => (
                <StaffDisplay
                    key={index}
                    name={member.name}
                    role={member.role}
                    email={member.email}
                    bio={member.bio}
                    avatar={member.avatar}
                    fullWidth
                    underline
                />
            ))}
            <div className={styles.hereToListen}>
                <h1 className={styles.hereToListenTitle}>Here to Listen</h1>
                <p className={styles.hereToListenText}>
                    Book a meeting with the Safeguarding Team if you have any
                    concerns about your safety or wellbeing. You can do this
                    quickly through the Student Hub, where trained staff are
                    ready to listen and support you.
                </p>
                <div className={styles.hereToListenEmail}>
                    <EmailIcon />
                    <p>contact@gouspa.org</p>
                </div>
            </div>
        </div>
    );
};

export default Safeguarding;
